import React, { useEffect, useState } from "react";
import { api, formatApiError, fmtMXN, fmtDate } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Textarea } from "@/components/ui/textarea";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function Pagos() {
  const [pagos, setPagos] = useState([]);
  const [sucs, setSucs] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ monto: 0, concepto: "Mensualidad", metodo: "Manual" });

  const load = async () => {
    const [p, s] = await Promise.all([api.get("/admin/pagos"), api.get("/admin/sucursales")]);
    setPagos(p.data); setSucs(s.data);
  };
  useEffect(() => { load(); }, []);

  const onSave = async () => {
    if (!form.sucursal_id || !form.monto) return toast.error("Sucursal y monto requeridos");
    try {
      await api.post("/admin/pagos", { ...form, monto: parseFloat(form.monto) });
      toast.success("Pago registrado");
      setOpen(false); setForm({ monto: 0, concepto: "Mensualidad", metodo: "Manual" }); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center flex-wrap gap-2">
        <div>
          <h2 className="text-3xl font-black tracking-tight">Pagos de licencia</h2>
          <p className="text-sm text-muted-foreground mt-1">Registro manual de pagos por sucursal.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button><Plus className="h-4 w-4 mr-2" />Registrar pago</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuevo pago</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div>
                <Label>Sucursal *</Label>
                <Select value={form.sucursal_id} onValueChange={(v) => setForm({ ...form, sucursal_id: v })}>
                  <SelectTrigger><SelectValue placeholder="Selecciona sucursal" /></SelectTrigger>
                  <SelectContent>
                    {sucs.map((s) => <SelectItem key={s.id} value={s.id}>{s.cliente_nombre} — {s.nombre}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div><Label>Monto *</Label><Input type="number" step="0.01" value={form.monto} onChange={(e) => setForm({ ...form, monto: e.target.value })} /></div>
              <div><Label>Concepto</Label><Input value={form.concepto} onChange={(e) => setForm({ ...form, concepto: e.target.value })} /></div>
              <div><Label>Método</Label><Input value={form.metodo} onChange={(e) => setForm({ ...form, metodo: e.target.value })} /></div>
              <div><Label>Notas</Label><Textarea value={form.notas || ""} onChange={(e) => setForm({ ...form, notas: e.target.value })} /></div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
              <Button onClick={onSave}>Guardar</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <Card>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Fecha</TableHead>
                <TableHead>Sucursal</TableHead>
                <TableHead>Concepto</TableHead>
                <TableHead>Método</TableHead>
                <TableHead className="text-right">Monto</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {pagos.map((p) => {
                const suc = sucs.find((s) => s.id === p.sucursal_id);
                return (
                  <TableRow key={p.id}>
                    <TableCell>{fmtDate(p.fecha)}</TableCell>
                    <TableCell>{suc ? `${suc.cliente_nombre} — ${suc.nombre}` : p.sucursal_id}</TableCell>
                    <TableCell>{p.concepto}</TableCell>
                    <TableCell>{p.metodo}</TableCell>
                    <TableCell className="text-right font-bold">{fmtMXN(p.monto)}</TableCell>
                  </TableRow>
                );
              })}
              {pagos.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">Sin pagos</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
